import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';

type Args = {
	accountId: number;
	level: AiCostLimitLevel;
	subjectId: number;
	monthlyAmount: number;
	alertThresholdPercent: number;
};

class CreateAiCostLimit {
	readonly accountId: number;
	readonly level: AiCostLimitLevel;
	readonly subjectId: number;
	readonly monthlyAmount: number;
	readonly alertThresholdPercent: number;

	constructor(args: Args) {
		this.accountId = args.accountId;
		this.level = args.level;
		this.subjectId = args.subjectId;
		this.monthlyAmount = args.monthlyAmount;
		this.alertThresholdPercent = args.alertThresholdPercent;

		Object.freeze(this);
	}

	// `accountId` is the route identifier: it is never echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			level: this.level,
			subjectId: this.subjectId,
			monthlyAmount: this.monthlyAmount,
			alertThresholdPercent: this.alertThresholdPercent,
		};
	}
}

export default CreateAiCostLimit;
